import React from 'react'
import Tracks from '../tracks/Tracks'

export default () => {
  return (
    <React.Fragment>
      <Tracks />
    </React.Fragment>
  )
}
